import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import AcceptInvitation from 'pages/Login/AcceptInvitation';
import HealthCheck from 'pages/HealthCheck';
import TokenLogin from 'pages/Login/TokenLogin';
import Impersonate from 'pages/Login/Impersonate';
import Logout from 'pages/Login/Logout';
import ProtectedLayout from './components/ProtectedLayout';
import { RouteDefinitions } from './types/Routes';

export * from './types/Routes';

export const history = createBrowserHistory();

export const replaceParam = (route: string, param: string, replacement: string): string => {
  return route.replace(param, replacement);
};

const Routes = (): JSX.Element => {
  return (
    <Router history={history}>
      <Switch>
        <Route path={RouteDefinitions.TokenLogin} component={TokenLogin} />
        <Route path={RouteDefinitions.Logout} component={Logout} />
        <Route path={RouteDefinitions.Impersonate} component={Impersonate} />
        <Route path={RouteDefinitions.AcceptInvitation} exact component={AcceptInvitation} />
        <Route path={RouteDefinitions.HealthCheck} exact component={HealthCheck} />
        <ProtectedLayout />
      </Switch>
    </Router>
  );
};

export default Routes;
